import * as yup from 'yup'

export const SearchOnboardingCarrierSchema = yup.object({
  dotNumber: yup
    .number()
    .typeError('DOT number must be numeric')
    .test('len', 'DOT number must have a maximum length of eight digits', val =>
      val ? val.toString().length <= 8 : true
    )
    .nullable(true),
  mcNumber: yup
    .number()
    .typeError('MC number must be numeric')
    .test('len', 'MC number must have a maximum length of eight digits', val =>
      val ? val.toString().length <= 8 : true
    )
    .nullable(true),
})

export type TSearchOnboardingCarrierSchema = yup.InferType<typeof SearchOnboardingCarrierSchema>
